import _ from 'lodash';
import React from 'react';
import { cx, PropTypes } from '~/utils';

export function IconLayer( { children, className, ...props } ) {
  const classes = cx( 'fa-layers', 'fa-fw', className );
  return <span className={classes} {...props}>{children}</span>;
}
IconLayer.propTypes = {
  children    : PropTypes.node.isRequired,
  className   : PropTypes.className,
};
